import { next } from '@vercel/edge';

import { EdgeRequest } from './request';
import { EdgeResponse } from './response';
import type { Middleware, Props } from './types';

export class NextUse {
    private req: EdgeRequest;
    private readonly res: EdgeResponse;
    private readonly middlewares: Middleware[] = [];
    private readonly event: FetchEvent;

    constructor({ request, response = next(), event }: Props) {
        this.req = new EdgeRequest(request, request);
        this.res = EdgeResponse.from(response);
        this.req.originalUrl = this.req.parsedUrl;
        this.event = event;
    }

    public use(middleware: Middleware) {
        this.middlewares.push(middleware);

        return this;
    }

    public async run() {
        for (const middleware of this.middlewares) {
            const raw = await middleware(this.req, this.res, this.event);
            if (!(raw instanceof Response)) continue;

            const res = EdgeResponse.from(raw);
            const rewrite = res.headers.get('x-middleware-rewrite');
            const isSend = res.headers.has('x-petm-middleware-send');
            const isNext = res.headers.has('x-middleware-next');

            if (isNext) continue;

            if (rewrite && !isSend) {
                this.req = new EdgeRequest(rewrite, this.req);
                this.res.headers.set('x-middleware-rewrite', rewrite);
            } else {
                res.headers.delete('x-petm-middleware-send');
                this.res.headers.forEach((value, key) => {
                    if (key.startsWith('x-middleware')) return;
                    if (!res.headers.has(key)) res.headers.set(key, value);
                });

                return res;
            }
        }

        const res = EdgeResponse.from(next({ request: this.req, headers: this.res.headers }));

        if (res.headers.has('x-middleware-rewrite')) {
            res.headers.delete('x-middleware-next');
        }

        return res;
    }
}
